// import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const zh = {
	navbar: {
		cxq: '创新区',
		st: '期待',
		home: '首页',
		pool: '矿池',
		blockinfo: '区块信息',
		paymenthistory: '历史支付',
		calc: '收益计算',
		autominer: '自助挖矿',
		mineraddress: '匿名挖矿',
		error: '错误',
		ica: '请输入正确的钱包地址',
		inhint: '请输入门罗钱包地址',
		inhinttitle: '提示',
		iem: '门罗地址格式不正确',
		confirm: '确定',
		cancel: '取消',
		quertButton: '查看',
		chat: "聊天室",
		login: "登录"
	},
	footer: {
		product: '产品',
		product_item1: 'Star Map矿池',
		product_item2: '收益计算器',
		help: '帮助',
		help_item1: '如何使用xmrig-proxy',
		help_item2: '如何指定算法',
		help_item3: '使用xmrig-proxy',
		help_item4: '更多使用教程',
		about: '关于',
		about_item1: '关于我们',
		about_item2: '隐私政策',
		about_item3: '服务协议',
		about_item4: '免责声明',
		qgroup: '官方QQ群：',
		qgroup_item1: '一群：',
		qgroup_item2: '二群：',
		qgroup_item3: '三群：',
		qgroup_item4: '四群：',
		qgroup_item5: '五群：',
		full: '(满)',
		links: '友链：'
	},
	index: {
		pool_title: '星图，不一样的挖矿体验',
		pool_desc: '一站式服务，让一切变得简单',
		netdiff: '当前全网难度',
		algo: '币种算法',
		coinstatus: '币种状态',
		fee: '费率',
		paymenttime: '付款时间',
		payThreshold: '起付额',
		payfre: '每两小时',
		cnaddress: '国内挖矿地址',
		foreignaddress: '全球节点',
		tlsaddrss: '加密挖矿地址',
		coinname: '币种',
		syl: '收益率',
		syl_desc: '该百分比为收益率，是当前币种算力和门罗算力的换算比率',
		price: '币价',
		award: '奖励',
		effort: '工作量',
		poolHash: '矿池算力',
		netHash: '全网算力',
		minercount: '活跃矿工',
		help: '帮助',
		chartspriceunit: '价格￥',
		chartshashunit: '算力',
		chartstitle: '历史算力&价格',
		coinstat: '正常',
		coinstat2: '异常',
		coinstatus: '状态正常',
		copysuccess: '复制成功',
		copysuccess_msg: '请粘贴到配置文件使用',
		tiptitle: '提示',
		helpdoc: '帮助文档',
		paymenttime2:"12:00-16:00",
		payType:"ETH",
		payfre2: '12:00-16:00',
		support:"提现方式",
		netdiff:"全网难度",
		cpu:"CPU机枪区",
		gpu:"GPU创新区"
	},
	block: {
		title: '区块信息',
		selectcoin: '选择查看币种:',
		table_id: '序号',
		table_ts: '时间',
		table_effort: '幸运度',
		table_rawaward: '原始奖励',
		table_payment: '支付(XMR)',
		table_blockheight: '区块高度',
		mins: '分钟',
		soon: '即将完成',
		delay: '延迟',
		nullify: '无效',
		secago: '秒前',
		minago: '分钟前',
		hourago: '小时前',
		dayago: '天前',
		monago: '月前',
	},
	calc: {
		title: "门罗币 Monero (XMR)挖矿收益计算器",
		kw: '矿机功率',
		df: '电价(度)',
		yjcb: '硬件成本',
		kccs: '矿池抽水',
		dqbj: '当前币价',
		kjsl: '矿机算力',
		input_kw: '请输入功率',
		input_df: '请输入电价',
		input_cb: '请输入成本',
		input_csbl: '请输入抽水比例',
		input_dqbj: '当前币价',
		input_sl: '请输入算力',
		buttontitle: '计算收益',
		wfhb: '无法回本',
		hbsj: '回本时间',
		nethash: '全网算力',
		nethiff: '挖矿难度',
		gjbj: '关机币价',
		mrjsy: '每日净收益',
		mzjsy: '每周净收益',
		myjsy: '每月净收益',
		mnjsy: '每年净收益',
		mrcz: '每日产值',
		mryd: '每日用电',
		mrdf: '每日电费',
		mzcz: '每周产值',
		mzyd: '每周用电',
		mzdf: '每周电费',
		mycz: '每月产值',
		myyd: '每月用电',
		mydf: '每月电费',
		mncz: '每年产值',
		mnyd: '每年用电',
		mndf: '每年电费',
		r: '日',
		z: '周',
		y: '月',
		n: '年',
	},
	autominer: {
		title: 'XMRIG挖矿工具自动生成',
		title_desc: '请在下方选择合适的系统版本配置您的矿工，默认已打开您适合的版本（默认仅供参考）',
		win: 'Windows系统',
		linux: 'Linux系统',
		mac: 'Mac系统',
		wallet_address: '钱包地址',
		minername: '矿工名称',
		wallet_input: '请输入钱包地址',
		minername_input: '请输入矿工名',
		ljsc: '立即生成',
		dqsb: '当前设备信息',
		dqllq: '当前浏览器',
		dqxt: '当前操作系统',
		jianyi: '建议使用版本',
		input_add: '请输入门罗钱包地址',
		input_cadd: '请输入正确的门罗地址',
		err: '错误',
		errmsg: '钱包地址错误',
		errmsg2: '未知错误，未能配置成功',
		warn: '警告',
		warnmsg: '尚未选择系统分类，无法生成',
		panel_win: '当前设备适用于window版本，已为您打开面板',
		panel_linux: '当前设备适用于Linux版本，已为您打开面板',
		panel_mac: '当前设备适用于Mac版本，已为您打开面板',
		panel_mobile: '当前设备为移动端设备，请使用PC端配置生成',
		panel_ubknown: '当前未找到您设备匹配的版本，请自行选择版本或体验Web挖矿',


	},
	anonminer: {
		online: '在线',
		offline: '离线',
		offline_table: '暂无数据',
		wallet_address: '钱包地址:',
		input_tip: '请输入钱包地址',
		input_over: '查看',
		panel_title_1: '我的面板',
		panel_title_2: '我的矿机',
		panel_title_3: '支付历史',
		panel_title_4: '机枪币区块支付历史',
		panel_title_5: '我的设置',
		title_hash: '算力',
		title_miner: '矿工',
		title_earnings: '收益',
		realhahs: '实时算力',
		realhahs_desc: '转换为门罗算法后的算力',
		avghash24: '24小时平均',
		avghash24_desc: '24小时内平均算力',
		avghash4: '4小时平均',
		avghash4_desc: '4小时内平均算力',
		due: '待支付',
		paid: '已支付',
		chartstip: '有疑问点我',
		mineremputtip: '暂无矿机',
		id: '序号',
		minername: '矿机名',
		lts: '最后提交时间',
		payhash: 'pay算力',
		rawhash: 'raw算力',
		validshares: '有效份额',
		invalidshares: '无效份额',
		totalhash: '总提交哈希',
		input_search_miner: '输入矿机名搜索',
		clickmore: '点我查看详细算力',
		paymentdate: '支付日期',
		paymentvalue: '支付金额(XMR)',
		blockpaymentdate: '区块支付时间',
		blockfounddate: '区块发现时间',
		blockpercent: '区块份额(%)',
		blockname: '币种名称',
		clickcopy: '点击复制完整hash',
		prepage: '上一页',
		nextpage: '下一页',
		minercount: '矿工数',
		totalshares: '总提交份额',
		activeminer: '当前在线矿工数',
		minerunit: '个矿工',
		gxxe: '更新限额',
		reset: '重置',
		setaddress: '地址管理',
		addressempty: '暂时还没有存到钱包地址',
		cz: '操作',
		del: '删除',
		yjjb: '一键脚本',
		winjb: 'Windows一键脚本',
		linuxjb: 'Linux一键脚本',
		copyjb: '点我复制',
		paychartstitle: 'PAY历史算力',
		rawchartstitle: 'RAW历史算力',
		paychartsunit: 'pay算力',
		rawchartsunit: 'raw算力',
		linkwalleterr: '链接中的钱包地址错误',
		copysuccess: '复制成功',
		copyerror: '该浏览器不支持自动复制',
		yqtx: '友情提醒：',
		tomoreminer: '您矿机数量过多，这将导致加载数据过慢，请耐心等待！',
		warntip: '警告',
		warntip_desc: '尚未输入钱包地址，历史算力无法显示',
		sec: '秒',
		mins: '分',
		hour: '小时',
		zdxe: '最低限额为0.003XMR',
		success: '成功',
		updatesuccess: '更新限额成功',
		unknownerror: '未知原因',
		unknownerror_desc: '更新限额失败',
		updatewarn: '24小时内仅能更新一次',
		updatewarn_desc: '剩余时间：',
		echartsquestiontip: '表数据为近几天内每分钟数据，如波动较大属正常现象',
		echartsquestiontiptitle: '图表波动解释',
		confirmbutton: '确定',
		msgtokf: '如有其他问题请咨询客服',
		valid: '有效:',
		invalid: ',无效:',
		lts2: '最后提交时间：',
		secago: '秒前',
		minago: '分钟前',
		hourago: '小时前',
		dayago: '天前',
		monago: '月前',
		onesecago: '1秒前',
		wallet_emptytip: '请输入钱包地址进行查询',
		shell_install: '安装',
		shell_uninstall: '卸载',
		txfee: "tx fee (门罗网络转账费) ：+0.0001XMR"
	},
	paymenthistory: {
		title: '支付历史',
		pay_ts: '支付时间',
		pay_payees: '支付人数',
		pay_value: '金额(XMR)',
		pay_fee: '网络转账费 (XMR)',
	},
	navbar2: {
		login: "登录",
		logout: "退出",
		usercenter: "个人中心",
		loginfail: "登陆失效，请重新登陆",
	},
	sidebar: {
		selectcoin: "币种选择",
		usersetting: "用户设置",
		course: "教程",
		discord1: "创新区交流",
		discord2: "Star Map 中文社区",
		course2:"提款教程",
		invite:"邀請推广",
		inmail:"站内通知",
		yubibao:"币生息",
		jinrong:"金融",
		baoxian:"保险",
		wange:"网格交易",
		jiedai:"借贷",
		bilicai:"双币理财",
		wallet:"钱包"
	},
	labseth: {
		myaccount: "我的子账户",
		addaccount: "添加子账户",
		accountName: "账户名",
		remark: "备注",
		confirm: "确定",
		cancel: "取消",
		changeaccount: "切换子账户",
		accountid: "子账户UID",
		accountName2: "子账户名",
		option: "操作",
		select: "选择",
		tobesubbalance: "待提现收益",
		nowsubbalance: "立即提现",
		online: "在线",
		realtimehash: "实时算力",
		empty: "暂无矿机",
		stale: "延时份额",
		minedisc: "挖矿收益说明",
		earnmodel: "收益模式",
		fee: "费率",
		intoaccount: "到账时间",
		intoaccountdisc: "当天提现,第二天到账",
		support: "支持",
		realearn:"实时收益",
		bindgoogle: "绑定谷歌验证器",
		googledisc: "谷歌验证器是一款动态口令工具,工作原理类似短信动态验证,绑定后动态密钥每30秒变动一次,可用于登陆.提现,修改安全设置等安全验证。",
		step1: "步骤 1:下载谷歌验证器APP",
		step1disc: "iOS用户登录App Store搜索“Authenticator”下载，安卓用户登录应用商店或者使用手机浏览器搜索“谷歌验证器”下载。",
		step2: "步骤 2:在谷歌验证器中添加密钥并备份",
		step2disc: "打开谷歌验证器，扫描下方二维码或手动输入下方密钥添加验证令牌。",
		googeldisc2: "密钥用于修改密码或账号遗失找回谷歌验证器,绑定前请务必将密钥备份保存并防止泄露!",
		step3: "步骤 3:验证谷歌验证器中的6位验证码",
		googelcode: "谷歌验证码",
		googlecodetip: "请输入谷歌验证器中的验证码",
		googelcodeconfirm: "立 即 验 证",
		addpaymentaccount: "添加付款账户",
		paymentaccounttip: "您尚未绑定谷歌验证，将无法提现",
		clickmetobind: "点我绑定",
		biantip: "仅支持Binance Smart Chain(BEP20/BSC)网络",
		usdttip: "仅支持Tron(TRC20)网络",
		alipaytip: "请牢记该密钥，这将关系到提现问题（请使用字母+数字定义密钥）",
		addtype: "添加类型",
		selectaddtype: "请选择添加类型",
		key8: "8位密钥",
		accountaddress: "账户地址",
		alias:"别名",
		accountalias:"账户别名",
		nowadd:"立即添加",
		tixian:"提现",
		paymentoption:"提现操作",
		addpaymentorderaccount:"添加提现账户",
		paymenttipwithgoogle:"您尚未绑定谷歌验证，将无法提现",
		usdtsdisc1:"USDT将使用TRX链【Tron(TRC20)】进行支付",
		usdtsdisc2:"最低提现:20 USDT",
		ethdisc1:"ETH将使用BSC链【Binance Smart Chain(BEP20)】进行支付",
		ethdisc2:"到账金额将扣除网络费用",
		ethdisc3:"最低提现:0.01 ETH",
		ethdisc4:"最低提现:0.5 ETC",
		selectkey:"选择您提现使用的密钥,不绑定邮箱提现将无法到账",
		alipaydisc:"最低提现:100 CNY",
		paymenttype:"提现类型",
		selectpaymenttype:"请选择提现类型",
		usdtpayment:"USDT 网络转账费:1 USDT",
		ethpayment:"ETH(BSC) 网络转账费:0.000070 ETH",
		alipaypayment:"Alipay 手续费:1%",
		ketishuliang:"可提数量",
		payaccount:"提现账户",
		selectpayaccount:"请选择提现账户",
		paycount:"提现数量",
		all:"全部",
		tixiantip:"当日0点前提现，将于次日中午12:00 - 下午16:00处理",
		nowpay:"立即提现",
		paymenthistory:"提现记录",
		date:"日期",
		id:"编号",
		type:"类型",
		unknown:"未知",
		money:"金额",
		search:"输入关键字搜索",
		wcl:"未处理",
		clz:"处理中",
		yzf:"已支付",
		yth:"已退回",
		err:"异常",
		nodeaddress:"节点地址：",
		nodetip:"请不要使用含有中文名的挖矿账户或矿工名，以免给您带来不必要的损失！",
		t_rex:"t-rex挖矿参数：",
		minername:"挖矿账户",
		minname:"矿工名",
		phoexminer:"PhoenxMiner挖矿参数：",
		nbminer:"Nbminer挖矿参数:",
		gminer:"Gminer挖矿参数:",
		teamredminer:"Teamredminer挖矿参数:",
		input:"请输入六位验证码",
		codeerr:"验证码格式错误",
		inputeth:"请输入ETH钱包地址",
		addresserr:"钱包格式错误",
		balanceinsuf:"余额不足",
		googelcodetitle:"请在手机端打开谷歌验证APP并输入手机上显示的六位验证码",
		googelcodetip:"请输入验证码",
		confirmbtn:"确定",
		coderegerr:"验证码格式不正确",
		optinerr:"非法操作！",
		codeerr1:"验证码错误",
		unknown:"未知错误",
		addsuccess:"添加成功",
		addfail:"添加失败",
		addexist:"该子账户已存在",
		loginfail:"登陆状态失效，重新登陆",
		addtip:"子账户名以st_开头",
		bindsuccess:"绑定成功",
		copysuccess:"复制成功",
		copytip:"请务必保存妥当",
		unbindgoogel:"尚未绑定谷歌验证，请先绑定！",
		banaccount:"账户被封禁，请发起工单处理",
		cnypaytip:"最低100CNY起提现",
		usdtpaytip:"最低20USDT起提现",
		ethpaytip:"最低0.01ETH起提现",
		addpaysuccess:"提现成功",
		addpayfail:"创建订单失败",
		addpayonceday:"每天仅限提现一次",
		addpaybalanceinsuff:"余额不足",
		unbindemaill:"未绑定邮箱，无法使用Alipay提现",
		down:"下载工具",
		minersetting:"挖矿设置参数",
		alipaykeyerr:"Alipay密钥格式错误,仅支持数字、字母",
		accountmanager:"提现账户管理",
		addresserr:"地址错误",
		unknownerr:"未知错误",
		openlist:"开启翻页",
		closelist:"关闭翻页",
		deletesuccess:"移除成功",
		deleteerror:"移除失败",
		accounttype:"类型",
		accountaddress:"地址",
		accountname:"别名",
		accountoption:"操作",
		accountremove:"移除",
		hashcharts:"12小时算力图",
		lastdayearn:"昨日收益",
		todayearn:"今日收益",
		lastdayearndisc:"昨日00:00:00-23:59:59(第一天挖矿益会有一次收益在第二天发放)",
		todayearndisc:"今日00:00:00至今的收益",
		sfsyobserver:"是否启用观察者",
		observertip:"开启后,可在免登陆查询矿工信息",
		copyobserver:"复制",
		openobserver:"打开",
		miner:"矿机",
		earning:"收益",
		
		hashrate:"算力",
		totalshare:"总份额",
		Valid:"有效份额",
		Stale:"延迟份额",
		Invalid:"无效份额",
		miners:"矿机",
		localhash:"本地算力",
		invite:"邀請",
		standby:"备用",
		temporarymaintenance:"临时维护",
		okextip:"仅支持OKEx Chain(OKC)网络",
		okexpayment:"ETH(OKC) 免手续费",
		okexdisc1:"ETH将使用OKC链【OKEx Chain】进行支付",
		bankcard:"银行卡提现 手续费:2%",
		realname:"真实姓名",
		noresubmit:"请勿重复提交",
		unknown1:"未知",
		jine:"金额(约)：",
		wallet_address2:"钱包地址：",
		tixiantype:"提现类型：",
		tixiandilogtip:"请仔细确认钱包地址，提交后无法更改！",
		eachEarn:"每M收益",
		thresholdTip:"预更改阈值：",
		thresholdTip2:"提现阈值最小为0.05",
		walletTip:"预修改提现地址为：",
		walletTip2:"需Ethereum Classic主网地址，请确认钱包是否正确,因绑定错钱包而造成损失需自己承担后果。",
		walletTip3:"仅支持ETC主网，请确认钱包是否正确以免造成不必要的损失。",
		gohash:"点我查看",
		address:"提现地址",
		txhash:"交易记录",
		closure:"暂停提现，恢复时间等待通知"
		
		
		
	},
	observer:{
		wktobserver:"该子账户未开通观察者"
	},
	noticelist:{
		check:"查看",
		personalnotice:"个人通知",
		systemnotice:"系统通知"
		
	},
	bata:{
		wallet:"钱包业务内测中,",
		yubibao:"币生息业务内测中,",
		baoxian:"保险业务内测中,",
		wange:"网格交易业务内测中,",
		jiedai:"借贷务内测中,",
		bilicai:"双币理财业务内测中,",
		tip:"目前仅对拥有内测资格的用户开放使用"
	}


}
export default zh;
